const checkoutButton = document.querySelector('#custom-checkout')
const cartItemsElement = document.querySelectorAll('.cart-item')

const getOrderDataFromLocalStorage = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_DRAFT_ORDER_KEY))

const setOrderDataToLocalStorage = (draftOrderData) => localStorage.setItem(LOCAL_STORAGE_DRAFT_ORDER_KEY, JSON.stringify(draftOrderData))

const deleteOrderDataFromLocalStorage = () => localStorage.removeItem(LOCAL_STORAGE_DRAFT_ORDER_KEY)

const updateCheckoutButtonWithDraftOrderLink = (draftOrderLink) => {
    checkoutButton.setAttribute('href', draftOrderLink)
}

const draftOrderExecuteQuery = async(method, data) => {
    return fetch(`${API_URL}/draftOrderCreate`, {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
}

const draftOrderExecuteQueryUpdate = async(method, data) => {
    return fetch(`${API_URL}/draftOrderUpdate`, {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
}

const getDraftOrderStatus = async (draftOrderId) => {
    return fetch(`${API_URL}/draftOrderStatus/${draftOrderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

const completeDraftOrder = async (data) => {
    return fetch(`${API_URL}/draftOrderComplete`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
}

const calculateDraftOrder = async (data) => {
    return fetch(`${API_URL}/draftOrderCalculate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    })
}

const updateDraftOrder = async(draftOrderData) => draftOrderExecuteQueryUpdate('PUT', draftOrderData)
const createDraftOrder = async(draftOrderData) => draftOrderExecuteQuery('POST', draftOrderData)

const updateDraftOrderData = () => {
    const quantityInputs = document.querySelectorAll('.quantity__input')
    let cartItems = []
    for (quantityInput of quantityInputs) {
        cartItems.push({
            quantity: quantityInput.value,
            variantId: `gid://shopify/ProductVariant/${quantityInput.getAttribute('data-quantity-variant-id')}`
        })
    }
    const previousDraftOrderData = getOrderDataFromLocalStorage()
    const newDraftOrdersData = {
        ...previousDraftOrderData,
        items: cartItems
    }
    setOrderDataToLocalStorage(newDraftOrdersData)
}


const removeCookie = (cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;domain=`
}

const deleteExpiredDraftOrder = async(draftOrderData, reloadAfterDeletion = false) => {
    const draftOrderIdWithoutShopifyPrefix = draftOrderData?.draftOrderId?.replace('gid://shopify/DraftOrder/', '')
    const draftOrderStatusResponse = await getDraftOrderStatus(draftOrderIdWithoutShopifyPrefix)
    const draftOrderStatusData = await draftOrderStatusResponse.json()

    if (draftOrderStatusData.draftOrderStatus !== 'OPEN' && draftOrderStatusData.draftOrderStatus?.length > 0) {
        deleteOrderDataFromLocalStorage()
        // removes shopify cart after draft order is complete
        removeCookie('cart')

        if (reloadAfterDeletion) {
            window.location.reload()
        }
    }

    return draftOrderStatusData.draftOrderStatus
}

document.addEventListener('DOMContentLoaded', async() => {
    updateDraftOrderData()
    const draftOrderData = getOrderDataFromLocalStorage()
    await deleteExpiredDraftOrder(draftOrderData, true)
})

window.updateDraftOrderData = updateDraftOrderData
